import { ApplyButton, SectionHeader } from "./shared";

export default function HomeFinalCta() {
  return (
    <section className="bg-[#f5fffa] px-4 sm:px-6 lg:px-[80px] py-[60px]">
      <div className="max-w-[1280px] mx-auto flex flex-col items-center gap-10 lg:gap-14">
        <SectionHeader
          badge="Next Step"
          title="Ready to Explore Your Loan Options?"
          subtitle="Understand your loan amount, charges and repayment terms before starting your application."
        />
        <ApplyButton label="Apply for a Personal Loan" location="home_final_cta" className="px-10 py-4" />
      </div>
    </section>
  );
}
